import { render, staticRenderFns } from "./TabsModal.vue?vue&type=template&id=0000958e&scoped=true"
import script from "./TabsModal.vue?vue&type=script&lang=js"
export * from "./TabsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0000958e",
  null
  
)

export default component.exports